import { Component, inject, signal } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { IconoRegistroService } from '@shared/icons/icono-registro.service';
import { CambiarTemaService } from '@shared/services/cambiar-tema.service';
import { LoaderService } from '@shared/services/loader.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('sistema-reclutamiento-frontend');
  private temaService = inject(CambiarTemaService);
  private iconoRegistroService = inject(IconoRegistroService);
  readonly loadingService = inject(LoaderService);
  constructor(private iconRegistry: MatIconRegistry) {
    // Establecemos 'material-symbols-outlined' como la clase por defecto
    this.iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.iconoRegistroService.init();
    this.temaService.aplicarTema();
  }
}
